// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__X02md","wheel":"Loader_wheel__RN-g4","cssload-animation1":"Loader_cssload-animation1__aekXJ","cssload-animation2":"Loader_cssload-animation2__TtFsp"};